module.exports = __webpack_public_path__ + "assets/img/Type E (8).c0d0ca2b.jpg";